import links from "@/links/links";

export default {
  actions: {
    MANDATE_PDF_CREATE_MERGE(meetingId, templates, mandateId) {
      return this.post(links.MANDATE_PDF_CREATE_MERGE(), {
        meetingId: meetingId,
        templates: templates,
        mandateId: mandateId,
      });
    },
    MANDATE_PDF_UPDATE_CORRESPONDENCE(templates, mandateId) {
      return this.post(links.MANDATE_PDF_UPDATE_CORRESPONDENCE(), {        
        templates: templates,
        mandateId: mandateId,
      });
    },
    GET_LOGO_IN_BASE64(id) {
      return this.get(links.MEDIA_GET_IN_BASE64(id), { save: false });
    },
  },
};